import React, { FC } from 'react'
import { IconButton } from '@wmgtech/legato'
import { useFormContext } from 'react-hook-form'

import styles from './actionbutton.module.scss'

export const ActionButton: FC = () => {
  const { reset } = useFormContext()

  return (
    <div className={styles.container}>
      <IconButton
        message="Cancel Edit"
        className={styles.btn}
        colorType="danger"
        icon="xmark"
        onClick={() => reset()}
        data-testid={'product-cancel-button'}
      />
      <IconButton data-testid={'product-submit-button'} message="Save Product" colorType="success" htmlType="submit" icon="check" className={styles.btn} />
    </div>
  )
}
